import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import PlanEditor from "../../components/PlanEditor";
import { buildPlanInput, planToForm, presetToForm, PLAN_PRESETS } from "../../lib/planPresets";
import {
  currentPeriod,
  fetchPlatformTenant,
  generateInvoiceDraft,
  setTenantPlan,
} from "../../lib/opsGraphql";
import UsageProgressBar from "../../components/UsageProgressBar";

export default function TenantPlanForm() {
  const { tenantId } = useParams();
  const [planForm, setPlanForm] = useState(presetToForm(PLAN_PRESETS[1]));
  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");
  const period = currentPeriod();

  useEffect(() => {
    fetchPlatformTenant(tenantId)
      .then((detail) => {
        const plan = detail?.commercial_plan;
        setUsage(detail?.usage_summary);
        if (plan) setPlanForm(planToForm(plan));
      })
      .catch((e) => setError(e.message));
  }, [tenantId]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setInfo("");
    try {
      await setTenantPlan(buildPlanInput(tenantId, planForm));
      setInfo("Plan actualizado.");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const onGenerateDraft = async () => {
    setLoading(true);
    setError("");
    try {
      const draft = await generateInvoiceDraft(tenantId, period);
      setInfo(`Borrador generado: $${(draft.amount_ars || 0).toLocaleString("es-AR")}`);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <p>
        <Link to={`/tenants/${tenantId}`}>← Volver a ficha</Link>
        {" · "}
        <Link to={`/planes?tenant=${tenantId}`}>Gestión de planes</Link>
      </p>
      {error && <p className="ops-error">{error}</p>}
      {info && <p className="ops-info">{info}</p>}

      {usage && (
        <div className="ops-card ops-usage-preview">
          <h3>Consumo ({usage.period})</h3>
          <UsageProgressBar used={usage.documents_processed} limit={usage.documents_limit} label="Documentos" />
          <UsageProgressBar
            used={usage.fallback_tokens_used}
            limit={
              usage.fallback_tokens_included && usage.fallback_tokens_included > 0
                ? usage.fallback_tokens_included
                : null
            }
            label="Fallback tokens"
          />
        </div>
      )}

      <div className="ops-card">
        <h2>Plan comercial</h2>
        <form onSubmit={onSubmit}>
          <PlanEditor value={planForm} onChange={setPlanForm} />
          <div style={{ marginTop: 16, display: "flex", gap: 8 }}>
            <button type="submit" className="ops-btn" disabled={loading}>
              Guardar plan
            </button>
            <button type="button" className="ops-btn secondary" disabled={loading} onClick={onGenerateDraft}>
              Generar borrador de factura
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
